module.exports = __webpack_public_path__ + "img/icon_map_sdcy_c.b462852b.png";